import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Protected Route Component
 * 
 * Redirects to signin if user is not authenticated
 * Shows loading state while checking auth
 */
const ProtectedRoute = ({ children, requirePro = false }) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to signin if not authenticated
  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // Check Pro requirement
  if (requirePro && !profile?.is_pro) {
    return <Navigate to="/pricing" state={{ from: location, requirePro: true }} replace />;
  }

  return children;
};

export default ProtectedRoute;
